export default {
    data() {
        return {
            selectedRow: null,
            timeDelayedValueTimer: null,
            dataTablePageSettings: { pageSizes: true, pageSize: 100, pageSizes: [50, 100, 200, 300]},
        }
    },
    methods: {
        dataTableRowOnClick(args) {
            if (args.cellIndex === 0) {
                this.selectedRow = args;
                this.update();
            }
        },
        dataTableDataStateChange(args) {
            if (args.action.requestType === 'paging') {
                this.dto.PageRows = args.take
                this.dto.PageNumber = args.action.currentPage;

                this.getAll();
            }

            if (args.action.requestType === 'sorting') {
                if (args.sorted) {
                    this.dto.SortByColumn = args.sorted[0].name;

                    if (args.sorted[0].direction === 'ascending') {
                        this.dto.SortDirection = 'asc';
                    } else if (args.sorted[0].direction === 'descending') {
                        this.dto.SortDirection = 'desc';
                    }
                }

                this.getAll();
            }
        },
        clearSearchText() {
            this.dto.SearchText = '';

            this.getAll();
        },
        timeDelayedGetAll() {
            if (this.dto.SearchText.length === 0) {
                this.getAll();
                return;
            }

            if (this.timeDelayedValueTimer) {
                clearTimeout(this.timeDelayedValueTimer)
            }

            this.timeDelayedValueTimer = setTimeout(() => {
                this.getAll();
            }, 1000);
        },
    }
}